import { SupportedLocale } from "@intocare/datatypes/lib/i18n";

import { SubmittedAssessmentReportData } from "./types";
import { createConfiguredPdf } from "../../shared/pdf-maker";
import { createDocumentContextFor } from "../templates/document-context";
import { getSubmittedAssessmentDefinition } from "../templates/submitted-assessment-report";

export const generateSubmittedAssessmentReport = (
	data: SubmittedAssessmentReportData,
	locale: SupportedLocale,
	user?: string,
) => createConfiguredPdf(getSubmittedAssessmentDefinition(createDocumentContextFor({ locale }), data, user));
